import { useRouter } from 'next/router'
import FaqPage from '../../components/faq/FaqPage'
import FaqNew from '../../components/pages-new/FaqNew'

import { serverSideTranslations } from 'next-i18next/serverSideTranslations'

const titleProps = {
  title:
    'FAQ คำถามที่พบบ่อย ส่งต่างประเทศ - ส่งกี่วันถึง ประกันยังไง ขนส่งหยุดวันไหน',
  keywords:
    'ส่งของต่างประเทศ, ส่งของ ต่างประเทศ, ค่าส่งของต่างประเทศ, วิธีแพ็คของ,ประกัน พัสดุ',
  description:
    'SHIPPOP ส่งพัสดุไปต่างประเทศ สารพัดคำถามการส่งของไปต่างประเทศ วิธีการแพ็คของส่งของไปต่างประเทศ เช็คค่าส่งพัสดุต่างประเทศ วันหยุด สินค้าต้องห้าม และประกัน',
}

// ?old → old-design variant (mirrors pages/faq.js); otherwise the NEW design
// renders. FaqNew already supports type="inter" (getFaqInter). Each branch is
// its own component tree so hook order stays stable across both paths.
const FaqInterPage = () => {
  const { query } = useRouter()
  if ('old' in query) return <FaqPage type="inter" {...titleProps} />
  return <FaqNew type="inter" {...titleProps} />
}

export const getServerSideProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      'common',
      'header',
      'footer',
      'pdpa',
      'faq',
    ])),
  },
})

export default FaqInterPage
